import { ENDPOINT_BASE } from '@/config/endpoints'

/**
 * Project-settings endpoints are nested under the workspace path:
 *   /api/v1.0/e/{workspaceSlug}/projects/{projectId}/settings/...
 */
export const ENDPOINT_PROJECT_SETTINGS = `${ENDPOINT_BASE}/e`
